import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';

const routes: Routes = [
    // {
    //     path: "error",
    //     component: ErrorPageComponent,
    //     data: {
    //         'type': 404,
    //         'title': 'Page Not Found',
    //         'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
    //     },
    // }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SharedRoutingModule { }
